import React, { Component, PropTypes } from 'react';
import onclickoutside from 'react-onclickoutside';
import Button from 'views/widgets/Button';
import PageviewEventForm from 'views/PageviewEvent/PageviewEventForm';
import PageViewIcon from 'views/BaseElements/PageViewIcon';
import styles from 'styles/views/AppPanel.css';
import cn from 'classnames';

export class DefinePageEvents extends Component {
  static propTypes = {
    projectId: PropTypes.string,
    visible: PropTypes.bool,
    pageviewId: PropTypes.string,
    removePageviewId: PropTypes.func
  }

  state = {
    openModal: false,
    pageviewId: null
  }

  componentWillReceiveProps (nextProps) {
    const { pageviewId } = nextProps;
    if (pageviewId) {
      this.setState({
        openModal: true
      });
    }
  }

  render () {
    const { openModal } = this.state;
    const { projectId, visible, pageviewId, removePageviewId } = this.props;
    return (
      <div
        style={{marginRight: 10}}
        className={cn(styles.h_o_m, styles.event_h_o_m)}>
        <Button
          label='Define Pageview Events'
          style={{visibility: visible ? '' : 'hidden'}}
          onClick={this.onClick}>
          <PageViewIcon/>
          Define Pageview Events
        </Button>
        {
          openModal &&
            <PageviewEventForm
              projectId={projectId}
              onHide={this.onHide}
              pageviewId={pageviewId}
              removePageviewId={removePageviewId}/>
        }
      </div>
    );
  }

  onClick = () => {
    this.setState({
      openModal: !this.state.openModal
    });
  }

  onHide = () => {
    this.setState({
      openModal: false
    });
  }
}

export default onclickoutside(DefinePageEvents, {
  handleClickOutside: function (instance) {
    return instance.onHide;
  }
});



/** WEBPACK FOOTER **
 ** ./src/views/PageviewEvent/DefinePageviewEvent.js
 **/